<div class="sc-textarea" [class.sc-textarea--with-icon]="!!icon">
    <label
      class="sc-textarea__label"
      *ngIf="label" [attr.for]="id ? id+'__textarea' : null"
      [class.sc-textarea__label--floating]="!!value"
      [class.label--focus]="hasFocus"
      [class.sc-text-area__label--floating-has-error]="hasError"
    >{{ label }}</label>
    <div class="sc-textarea__textarea-group">
        <textarea
            #elementRef
            class="sc-textarea__native-textarea"
            [class.has-error]="hasError"
            [disabled]="isDisabled"
            [attr.id]="id ? id+'__textarea' : null"
            [attr.inputmode]="inputmode"
            [placeholder]="(placeholder ? placeholder : '')"
            [readonly]="readonly"
            (blur)="onBlur($event)"
            (focus)="onFocus($event)"
            (input)="onInput($event)"
            [attr.maxLength]="maxlength"
            [rows]="rows"
            [cols]="cols"
        >{{value}}</textarea>

        <ng-container *ngIf="!!icon">
            <sc-icon [icon]="icon" *ngIf="!iconClickHandler"></sc-icon>
            <sc-icon [icon]="icon" *ngIf="iconClickHandler" (click)="iconClickHandler.subscribe()"></sc-icon>
        </ng-container>
    </div>
    <div class="sc-textarea__messages">
      <div *ngIf="!!charCounterMaxLength && !warningText"
           class="sc-textarea__char-counter"
           [ngClass]="{ 'sc-textarea__char-counter_error': isCharacterCounterExceeded() }">
        {{ characterCounter }}/{{ charCounterMaxLength }} caracteres
      </div>
      <div *ngIf="!!warningText" [innerHTML]="warningText"></div>
    </div>
    <sc-form-control-error
      [errorMessages]="errorMessages"
      [control]="control"
      [hasError]="hasError"
      [hidden]="hideError"
      [debounceTime]="debounceTime">
    </sc-form-control-error>
</div>
